function NotFound(props: {}) {
  return <p>Not Found Page</p>;
}

export default NotFound;
